import React, { useState } from 'react';
import * as Yup from 'yup';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import { Alert, Form, FormGroup, Spinner, Input } from "reactstrap";

import {
  BlockTitle,
  Button,
  Icon,
} from "src/components/Component";
import Axios from "axios";
import API_ROUTES from "../../../../config/api";
import { VIEWS } from "../../index";
import domain from 'src/config/domain';

function PasswordResetForm({ className, onSubmitSuccess, onSubmitFailure, setView, ...rest }) {
  const [submitted, setSubmitted] = useState(false);
  const domainConfig = domain();

  if (submitted === true) {
    return (
      <React.Fragment>
        <div className={`mb-5 ${domainConfig.styles.textColour}`}>
          <BlockTitle tag="h2" className={`text-3xl ${domainConfig.styles.textColour}`}>Password Reset Successful</BlockTitle>
          <br />
          <p className="fs-18px">You should now receive an email with further instructions on how to set your new password.</p>
          <Button color="secondary" size="l" className="mt-5" onClick={(event) => { event.preventDefault(); setView(VIEWS.LOGIN) }}>
            Back to login page
          </Button>
        </div>
      </React.Fragment>
    )
  }

  return (
    <Formik
      initialValues={{
        email: '',
      }}
      validationSchema={Yup.object().shape({
        email: Yup.string().email('Must be a valid email').max(255).required('Email is required'),
      })}
      onSubmit={async (values, {
        setErrors,
        setStatus,
        setSubmitting
      }) => {
        try {
          setSubmitting(true);

          await Axios(
            API_ROUTES.user['user:password:reset'](),
            {
              method: 'post',
              data: {
                email: values.email,
              },
            }
          );

          setSubmitted(true);
        } catch (error) {
          const message = 'This email address either does not exist within our systems or is unable to be reset';

          setStatus({ success: false });
          setErrors({ submit: message });
          setSubmitting(false);
        }
      }}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        isSubmitting,
        touched,
        values
      }) => {
        return (
          <React.Fragment>
            <div className={`mb-5 ${domainConfig.styles.textColour}`}>
              <BlockTitle tag="h1" className={`text-3xl ${domainConfig.styles.textColour}`}>Reset Your Password</BlockTitle>
              <br />
              <p>We will send you a link to reset your password to the email address provided.</p>
            </div>
            {errors.submit && (
              <div className="mb-3">
                <Alert color="danger" className="alert-icon">
                  {" "}
                  <Icon name="alert-circle" /> {errors.submit}
                </Alert>
              </div>
            )}
            <Form noValidate className="is-alter" onSubmit={handleSubmit}>
              <FormGroup>
                <div className="form-label-group">
                  <label className={`form-label ${domainConfig.styles.textColour}`} htmlFor="email">
                    Email Address
                  </label>
                </div>
                <div className="form-control-wrap">
                  <Input
                    type="text"
                    id="default-01"
                    name="email"
                    value={values.email}
                    bsSize="xl"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    placeholder="Enter your email address"
                    className="form-control-lg form-control"
                  />
                  {touched.email && errors.email && <span className="invalid">{errors.email}</span>}
                </div>
              </FormGroup>
              <FormGroup className="mt-5">
                <Button size="lg" className={`btn-block ${domainConfig.styles.buttonColour}`} type="submit" color="primary">
                  {isSubmitting ? <Spinner size="sm" color="light"> </Spinner> : "Reset Password"}
                </Button>
              </FormGroup>
            </Form>
          </React.Fragment>
        )
      }}
    </Formik>
  );
}

PasswordResetForm.propTypes = {
  className: PropTypes.string,
  onSubmitSuccess: PropTypes.func,
  onSubmitFailure: PropTypes.func,
  setView: PropTypes.func,
};

PasswordResetForm.defaultProps = {
  onSubmitSuccess: () => { },
  onSubmitFailure: () => { },
};

export default PasswordResetForm;
